import { render, staticRenderFns } from "./template-download.vue?vue&type=template&id=48f39b9f"
import script from "./template-download.ts?vue&type=script&lang=ts&external"
export * from "./template-download.ts?vue&type=script&lang=ts&external"
import style0 from "./template-download.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports